import PropTypes from 'prop-types';

import { Link } from '@vimeo/iris/typography';

const TableOfContents = function (props) {
  const { paths } = props;

  if (typeof paths !== 'object') {
    return null;
  }

  let links = {};
  Object.keys(paths).map(function (group) {
    const pathSpec = paths[group];
    const label = pathSpec.info['x-devsite-label'];

    links[label] = {
      anchor: group,
      paths: {},
    };

    Object.keys(pathSpec.paths).map(function (path) {
      const methods = pathSpec.paths[path];

      Object.keys(methods).map(function (method) {
        const methodSpec = methods[method];
        const anchor = methodSpec.operationId;

        links[label].paths[methodSpec.summary] = anchor;
      });
    });
  });

  return (
    <ul>
      {Object.keys(links).map(function (group, i) {
        let linkGroup = links[group];
        let linkPaths = linkGroup.paths;

        return (
          <li key={i}>
            <Link href={'#' + linkGroup.anchor} variant="minimal">
              {group}
            </Link>
            <ul>
              {Object.keys(linkPaths)
                .sort()
                .map(function (summary, ii) {
                  let anchor = linkPaths[summary];

                  return (
                    <li key={ii}>
                      <Link href={'#' + anchor} variant="minimal">
                        {summary}
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </li>
        );
      })}
    </ul>
  );
};

TableOfContents.propTypes = {
  paths: PropTypes.object,
};

export default TableOfContents;
